import React, { useMemo, useEffect } from "react";
import { connect } from "react-redux";
import { SubmissionError } from "redux-form";

import { FeatureManager, URLS } from "globalConstants";
import { userActions } from "store";

import { ResetPasswordPageForm } from "./resetPasswordPageForm";

const ResetPasswordPage = ({
	verifyCode,
	resetPassword,
	history,
	location,
}) => {
	const urlParams = useMemo(() => {
		let params = new URLSearchParams(location.search);
		return { userId: params.get("userId"), code: params.get("code") };
	}, [location]);

	useEffect(() => {
		if (!urlParams.userId || !urlParams.code) {
			history.push(URLS.login);
			return;
		}

		verifyCode(urlParams.userId, urlParams.code).catch(() => {
			history.push("/reset-password-link-error");
		});
	}, [history, urlParams, verifyCode]);

	const cancelClick = () => {
		history.push(URLS.login);
	};

	const handleSubmit = async values => {
		verifyCode(urlParams.userId, urlParams.code)
			.then(() => {
				resetPassword(urlParams.userId, urlParams.code, values.password)
					.then(() => {
						history.push(
							FeatureManager.isEnabled("fusionAuth")
								? URLS.login
								: "/reset-password-success",
						);
					})
					.catch(err => {
						if (err) {
							throw new SubmissionError({
								password: err?.detail,
							});
						}
					});
			})
			.catch(() => {
				history.push("/reset-password-link-error");
			});
	};

	return (
		<ResetPasswordPageForm
			onSubmit={handleSubmit}
			cancelClick={cancelClick}
		/>
	);
};

const mapDispatchToProps = {
	verifyCode: userActions.verifyCode,
	resetPassword: userActions.resetPassword,
};

const connectedResetPasswordPage = connect(
	null,
	mapDispatchToProps,
)(ResetPasswordPage);
export { connectedResetPasswordPage as ResetPasswordPage };
